import { Dot, DotsContainer } from './PaginationDots.styles';

interface PaginationDotsProps {
  currentPage: number;
  totalPages: number;
}

const PaginationDots = ({ currentPage, totalPages }: PaginationDotsProps) => {
  if (totalPages <= 1) {
    return null;
  }

  return (
    <DotsContainer>
      {Array.from({ length: totalPages }).map((_, index) => (
        <Dot active={index === currentPage} key={`page-${index}`} />
      ))}
    </DotsContainer>
  );
};

export default PaginationDots;
